import ConfigAPI from '@/config/api'
import moment from 'moment'
import instance from '@/config/http'

const ServiceAPI = {
  accesos() {
    var url = ConfigAPI.baseURL + 'acceso'
    var data = {
      acceso: 'GRAFICO_CONSUMO_CORRAL', // Esta es la data que quieres enviar
    }
    var respuesta = instance.post(url, data)
    return respuesta
  },
  get(fecha) {
    var url = ConfigAPI.baseURL + 'grafico_consumo_corral'
    var params = {
      fecha: fecha ? moment(fecha).format('YYYY-MM-DD') : null,
    }

    return instance.get(url, { params: params })
  },
  getDatosChart(filtro) {
    var url = ConfigAPI.baseURL + 'grafico_consumo_corral'
    var params = {
      fecha_desde: filtro.fecha_desde ? moment(filtro.fecha_desde).format('YYYYMMDD') : null,
      fecha_hasta: filtro.fecha_hasta ? moment(filtro.fecha_hasta).format('YYYYMMDD') : null,
    }

    // Si vienen corrales específicos, agregarlos como id_corrales[]
    if (filtro.id_corrales && filtro.id_corrales.length > 0) {
      params['id_corrales[]'] = filtro.id_corrales
    }

    return instance.get(url, { params })
  },
}

export default ServiceAPI
